import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { EMPTY, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private http = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);
  private baseUrl = `${environment.apiUrl}`;

  getUserProfile(userName?: string) {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;

    let params = new HttpParams();

    if (userName) {
      params = params.set('userName', userName);
    }

    return this.http.get(`${this.baseUrl}/users/profile`, { params });
  }

  updateUserProfile(data: any) {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;

    // Fields the user may intentionally clear — send '' so the backend empties them.
    const clearableFields = ['bio'];

    const cleanPayload = Object.fromEntries(
      Object.entries(data).filter(([k, v]) =>
        Array.isArray(v) ||
        (clearableFields.includes(k) && v === '') ||
        (v !== '' && v !== null && v !== undefined)
      )
    );

    return this.http.patch(`${this.baseUrl}/users/update-profile`, cleanPayload);
  }

  uploadProfileImage(formData: FormData): Observable<any> {
    return this.http.patch(`${this.baseUrl}/users/profile/upload`, formData);
  }

  /**
   * Searches users for @mention autocomplete.
   * Empty query  → returns viewer's friends (shown on first @ keystroke)
   * With query   → friends matching query first, then other users
   */
  searchUsersForMention(query: string, limit = 10): Observable<any> {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;

    const params = new HttpParams()
      .set('q', query)
      .set('limit', limit.toString());

    return this.http.get(`${this.baseUrl}/users/search`, { params });
  }

  changePassword(currentPassword: string, newPassword: string, confirmPassword: string): Observable<any> {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;
    return this.http.post(`${this.baseUrl}/users/change-password`, { currentPassword, newPassword, confirmPassword });
  }

  requestEmailChange(newEmail: string): Observable<any> {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;
    return this.http.post(`${this.baseUrl}/users/change-email/request`, { newEmail });
  }

  verifyEmailChange(otp: string): Observable<any> {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;
    return this.http.post(`${this.baseUrl}/users/change-email/verify`, { otp });
  }

  searchUsersForCollaboration(query: string, limit = 10): Observable<any> {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;
    const params = new HttpParams()
      .set('q', query)
      .set('limit', limit.toString());
    return this.http.get(`${this.baseUrl}/users/search-collaborators`, { params });
  }

}